/**
 * Balanced Living Tribe — Theme JavaScript
 * blt-theme.js
 */

(function () {
  'use strict';

  function initFadeIn() {
    var elements = document.querySelectorAll('.blt-fade');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      // Skip elements already made visible on a previous init call.
      // Prevents re-fading content when shopify:section:load re-runs initFadeIn.
      if (!el.classList.contains('is-visible')) {
        observer.observe(el);
      }
    });
  }

  function initMarqueeTouchPause() {
    var marquees = document.querySelectorAll('.blt-reviews__marquee');
    marquees.forEach(function (marquee) {
      marquee.addEventListener('touchstart', function () {
        marquee.querySelectorAll('.blt-reviews__row').forEach(function (row) {
          row.style.animationPlayState = 'paused';
        });
      }, { passive: true });
      marquee.addEventListener('touchend', function () {
        marquee.querySelectorAll('.blt-reviews__row').forEach(function (row) {
          row.style.animationPlayState = '';
        });
      }, { passive: true });
    });
  }

  function initNewsletterSuccess() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      document.querySelectorAll('.blt-newsletter__success').forEach(function (el) { el.style.display = 'block'; });
      document.querySelectorAll('.blt-newsletter__form').forEach(function (el) { el.style.display = 'none'; });
    }
  }

  function init() {
    initFadeIn();
    initMarqueeTouchPause();
    initNewsletterSuccess();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run fade init after Shopify customiser re-renders any section.
  // shopify:section:load fires every time a setting change triggers a section reload.
  document.addEventListener('shopify:section:load', function () {
    initFadeIn();
  });

})();
